module.exports = __webpack_public_path__ + "static/media/close.65823361.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/close.svg
// module id = 265
// module chunks = 0